import { createMap, forMember, mapFrom, constructUsing, mapWith } from "@automapper/core";
import { parse } from "date-fns";
import { produce } from "immer";
import { CommissionSubTypes, SecurityCase, UserProfile, AgentInfo, Platform, Channel } from "../../contract/pam.js";
import { userLabelViewModelTypeName, userLabelTypeName } from "../label/constants.js";
import "@apollo/client";
import "rxjs";
import "../../api/types.js";
import { sortByDate, formatTimestamp } from "../../utils/date.js";
import { getMirrorObject } from "../../utils/object.js";
import "react-intl";
import "@apollo/client/errors";
import "rxjs/operators";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import { UserProfileViewModelKeysTypeName, UserProfileQueryFieldsTypeName, UserProfileColumnSettingsKeysTypeName, AgentRevenueShareViewModelTypeName } from "./constants.js";
import { SecurityCaseViewModel, UserProfileViewModel, AgentInfoViewModel, UserProfileDownloadModel, AalViewModel } from "./types.js";
import "react-redux";
import "../../user-settings/components/UserSettingsProvider.js";
import "react-oidc-context";
import "react-router";
import "oidc-client-ts";
import "../../auto-mapper/AutoMapperProvider.js";
import "../../redux-folder/async-actions/actions.js";
import "../../redux-folder/async-actions/selectors.js";
import "../../intl/shared-resources/serverResponse.js";
import "typesafe-actions";
import "redux-observable";
import "../../redux-folder/async-action/action.js";
import "../../redux-folder/error-handling/action.js";
import "../../redux-folder/actions.js";
import "../../redux-folder/async-actions/reducers.js";
import "../../redux-folder/download/actions.js";
import "../../redux-folder/download/epics.js";
import "../../ioc-container/inversifyProvider.js";
import "react-hook-form";
import "fast-deep-equal";
import "normalizr";
import "fast-deep-equal/es6";
import "redux";
import "../../redux-folder/entity/epics.js";
import "../../redux-folder/entity/EntityProvider.js";
import "reselect";
import "../../redux-folder/realtime/RealtimeNotification.js";
import "./components/DataGrid.js";
import "./actions.js";
import "./epics.js";
import "./components/Platform.js";
import "../../components/download/DownloadCsvButton.js";
import "../../components/download/DownloadTemplate.js";
import "../../components/filter/FilterGroupNew.js";
import "moment-timezone";
import "../../components/input/validation.js";
import "../../components/input/DatePicker.js";
import "../../components/input/DateRangePicker.js";
import "../../components/input/StyledInput.js";
import "../../components/input/FormInput.js";
import "../../components/input/StyledFormInputHoc.js";
import "../../components/input/DateSinglePicker.localize.js";
import "../../components/input/hooks.js";
import "@mui/material";
import "../../components/filter/dateRangeFilter/DateRangeFilter.js";
import "../../components/filter/date-filter/DateFilter.js";
import "../../components/filter/TextFilterWithDropdown.js";
import "../../components/filter/MultiStepFilterDrawer.js";
import "../../components/filter/dateRangeFilter/MultiStepFilterDatePicker.js";
import "../../components/select/Select.js";
import "../../components/filter/TextFilter.js";
import "../../components/filter/valueRangeFilter/ValueRangeFilter.js";
import "../../components/filter/dateRangeFilter/localized.js";
import "../../components/filter/dateRangeFilter/DateRangeHistoricalFilter.js";
import "../../components/filter/MultiStepFilterApplyButton.js";
import "../../components/filter/MultiStepFilterInput.js";
import "../../components/filter/MultiStepFilterHoc.js";
import "../../components/chip/ChipRenderer.js";
import "../../components/select/selectStyle.js";
import "../../components/select/MultiSelectFooter.js";
import "../../components/select/MultiSelect.js";
import "../../components/select/MultiSelectItem.js";
import "../../components/select/SelectArrowIcon.js";
import "../../components/select/VirtualizedMultiSelectOptionList.js";
import "../../components/select/SingleSelect.js";
import "../../components/select/MultiSelectWithExclude.js";
import "../../components/select/MultiSelectTextCounterWithTooltip.js";
import "../../components/filter/PhoneFilter.js";
import "../brand-license/constants.js";
import "../country/components/CountryFilter.js";
import "../brand-license/components/BrandProvider.js";
import "../../components/alerts/NoAccessInfoMessage.js";
import "../brand-license/components/LicenseSelect.js";
import "../brand-license/components/BrandSelect.js";
import "../../components/circle-box/CircleBoxWithText.js";
import "../../components/label/EmptyLabel.js";
import "../../components/label/LabelHoc.js";
import "../../components/tooltip/Tooltip.js";
import "../../components/tooltip/AutoAdjustedWidthTooltip.styles.js";
import "../../components/tooltip/AutoAdjustedComplexTooltip.styles.js";
import "../../components/tooltip/MultiLineAutoAdjustedWidthTooltip.js";
import "@mui/material/colors";
import "@mui/material/locale";
import "@mui/material/styles";
import "../../style/hooks.js";
import "../../components/circle-box/CircleBox.js";
import "./components/Filters.js";
import "./components/P2PStatusCell.js";
import "./components/UserDetailsWDBalance.js";
import "./components/ReferralLinkButton.js";
import "./components/PlayerIdAutocomplete.js";
const userProfileMappingKeys = {
  agentRevenueShareViewModelList: "AgentRevenueShareViewModelList",
  agentRevenueShareViewModel: "AgentRevenueShareViewModel",
  agentRevenueShare: "AgentRevenueShare",
  agentRevenueShareInput: "AgentRevenueShareInput",
  agentRevenueShareList: "AgentRevenueShareList",
  agentRevenueShareViewModelListSerialized: "AgentRevenueShareViewModelListSerialized",
  agentPokerCashViewModel: "AgentPokerCashViewModel",
  agentPokerCash: "AgentPokerCash",
  agentPokerShareWeeklyBand: "AgentPokerShareWeeklyBand",
  agentPokerShareWeeklyBandViewModel: "AgentPokerShareWeeklyBandViewModel",
  commissionSubTypesModel: "CommissionSubTypes",
  commissionSubTypesViewModel: "CommissionSubTypesViewModel",
  commissionSubTypes: "CommissionSubTypes",
  commissionAllSubTypesViewModel: "CommissionAllSubTypesViewModel",
  userProfileViewModelKeys: "UserProfile.ViewModelKeys",
  userProfileDownloadFields: "UserProfile.DownloadFields"
};
class UserProfileMapping {
  createMapping(mapper) {
    const convertToPercents = (value) => !isNaN(value) && value !== null ? +(value * 100).toFixed(6) : null;
    const convertToDecimal = (value) => !isNaN(value) && value !== null ? +(value / 100).toFixed(6) : null;
    const commissionSubTypesMapping = {
      [CommissionSubTypes.CasinoGgr]: "CasinoGgr",
      [CommissionSubTypes.CasinoGgrAfterExternalCosts]: "CasinoGgrAfterExternalCosts",
      [CommissionSubTypes.CasinoWager]: "CasinoWager",
      [CommissionSubTypes.GlobalSpinsExpectedEggr]: "GlobalSpinsGgr",
      [CommissionSubTypes.PokerCashPloGgr]: "PloGgr",
      [CommissionSubTypes.PokerGgrAfterProPenaltiesAfterEcology]: "PokerGgr",
      [CommissionSubTypes.PokerGgrAfterProPenaltiesAfterEcologyNoInsurance]: "PokerGgrNoInsurance",
      [CommissionSubTypes.PokerMttGgr]: "MttGgr",
      [CommissionSubTypes.PokerNgrExcPloAfterProPenaltiesAfterEcology]: "PokerNgr",
      [CommissionSubTypes.SportsGgr]: "SportsGgr",
      [CommissionSubTypes.SportsWagerForSettledBets]: "SportsWager"
    };
    const commissionSubTypesViewModelMapping = getMirrorObject(commissionSubTypesMapping);
    createMap(
      mapper,
      SecurityCase,
      SecurityCaseViewModel,
      forMember(
        (vm) => vm.case_id,
        mapFrom((m) => m?.case_id)
      ),
      forMember(
        (vm) => vm.type,
        mapFrom((m) => m?.type)
      ),
      forMember(
        (vm) => vm.closed_at,
        mapFrom((m) => m?.closed_at)
      ),
      forMember(
        (vm) => vm.opened_at,
        mapFrom((m) => m?.opened_at)
      )
    );
    createMap(
      mapper,
      UserProfileViewModelKeysTypeName,
      UserProfileQueryFieldsTypeName,
      constructUsing((m) => {
        const mapper2 = {
          uid: ["uid"],
          full_name: ["first_name", "last_name"],
          nickname: ["nickname"],
          uid_link_security: ["uid"],
          uid_link_cs: ["uid"],
          uid_link_agent: ["uid"],
          uid_link_player_details: ["uid"],
          uid_link_agent_details: ["uid"],
          account_status: ["account_status"],
          withdrawal_status: ["withdrawal_status"],
          deposit_status: ["deposit_status"],
          casino_status: ["casino_status"],
          sportsbook_status: ["sportsbook_status"],
          security_cases: ["security_cases.type", "security_cases.case_id"],
          "latest_kyc.payment.account_verification_status": [
            "latest_kyc.payment.id",
            "latest_kyc.payment.account_verification_status"
          ],
          "latest_kyc.payment.account_verification_status_cs": [
            "latest_kyc.payment.id",
            "latest_kyc.payment.account_verification_status"
          ],
          phone: ["contact.mobile.full_number"],
          verified_phone: [
            "contact.verified_mobile.full_number",
            "contact.verified_mobile.area",
            "contact.verified_mobile.mobile"
          ],
          referrer_player_id: ["referral.inviting_user_id"],
          country: ["address.country_info.iso_alpha2_code"],
          lobby_access_status: ["lobby_access_status"],
          "security_cases.type": ["security_cases.type"],
          "security_cases.case_id": ["security_cases.case_id"],
          "security_cases.closed_at": ["security_cases.closed_at"],
          "security_cases.opened_at": ["security_cases.opened_at"],
          "latest_kyc.security.id": ["latest_kyc.security.id"],
          "latest_kyc.security.account_verification_status": [
            "latest_kyc.security.id",
            "latest_kyc.security.account_verification_status"
          ],
          username: ["username"],
          p2p_transfer_status: ["p2p_transfer_status"],
          platform: ["platform"],
          platform_narrow: ["platform"],
          deposit_total: ["finance.deposit.total.successful_amount"],
          withdrawal_approved_amount: ["finance.withdrawal.total.successful_amount"],
          withdrawal_approved_count: ["finance.withdrawal.total.successful_count"],
          withdrawal_pending_amount: ["finance.withdrawal.total.pending_amount"],
          balance: ["finance.balance"],
          ggr: ["finance.ggr"],
          lifetime_bonus: ["finance.lifetime_bonus"],
          bonus_ratio: ["finance.bonus_ratio"],
          "agent_info.default_agent_revenue_share_history": ["agent_info.default_agent_revenue_share_history"],
          "agent_info.is_agent": ["agent_info.is_agent"],
          "agent_info.latest_revenue_share.casino_share": ["agent_info.default_agent_revenue_share_history"],
          "agent_info.latest_revenue_share.poker_cash.nlh_sd": ["agent_info.default_agent_revenue_share_history"],
          "agent_info.latest_revenue_share.poker_cash.plo": ["agent_info.default_agent_revenue_share_history"],
          "agent_info.latest_revenue_share.poker_mtt": ["agent_info.default_agent_revenue_share_history"],
          "agent_info.latest_revenue_share.spins": ["agent_info.default_agent_revenue_share_history"],
          "agent_info.latest_revenue_share.sports": ["agent_info.default_agent_revenue_share_history"],
          referrer_username: ["referral.inviting_user_username"],
          email: ["contact.email"],
          verified_email: ["contact.verified_email"],
          "finance.balance": ["finance.balance"],
          referred_date: ["referral.referred_at"],
          gender: ["gender"],
          first_name: ["first_name"],
          last_name: ["last_name"],
          "phone.area": ["contact.mobile.area"],
          "phone.number": ["contact.mobile.mobile"],
          "birthday.seconds": ["birthday.seconds"],
          "date_of_joining.seconds": ["date_of_joining.seconds"],
          is_2fa_enabled: ["security_settings.is_2fa_enabled"],
          is_challenge_questions_enabled: ["security_settings.is_challenge_questions_enabled"],
          referrer: ["referral.inviting_user_id", "affiliate.btag"],
          register_marketing_code: ["marketing_info.register_marketing_code"],
          labels: ["labels.id", "labels.name", "labels.group.id", "labels.group.name", "labels.group.color"],
          national_id: ["region_player_info.national_id"],
          networks_BL: ["networks.uid", "networks.platform"],
          networks_PKW: ["networks.uid", "networks.platform"],
          "referral.personal_referral_link": ["referral.personal_referral_link"],
          "latest_login.logged_at_ts.seconds": ["latest_login.logged_at_ts.seconds"],
          "latest_kyc.payment.id": ["latest_kyc.payment.id"],
          "networks.uid": ["networks.uid"],
          "networks.platform": ["networks.platform"],
          aml_labels: ["aml_labels"],
          login_countries: ["countries"],
          vpn: ["vpn"],
          brand: ["brand"],
          license_type: ["license_type"],
          "finance.withdrawal.total.pending_count": ["finance.withdrawal.total.pending_count"],
          "finance.casino_coin_balance": ["finance.casino_coin_balance"],
          "finance.p2p_credit.successful_amount": ["finance.p2p_credit.successful_amount"],
          "finance.p2p_debit.successful_amount": ["finance.p2p_debit.successful_amount"],
          casino_ggr_lifetime: ["finance.ggr_lifetime.casino"],
          poker_ggr_lifetime: ["finance.ggr_lifetime.poker"],
          sports_ggr_lifetime: ["finance.ggr_lifetime.sports"],
          withdrawal_total: ["finance.withdrawal.total.successful_amount"],
          aal: ["aal"],
          p2p_override_status: ["p2p_override_status"],
          p2p_status: ["p2p_status"],
          "finance.withdrawable_balance": ["finance.withdrawable_balance"],
          "finance.non_withdrawable_balance": ["finance.non_withdrawable_balance"],
          commission_subtypes: ["commission_subtypes", "agent_info.default_agent_revenue_share_history"],
          master_agent_id: ["master_agent_id"],
          channel: ["channel"],
          "referral.personal_referral_code": ["referral.personal_referral_code"],
          copyReferralLink: ["referral.personal_referral_code"],
          details: []
        };
        return [...new Set(m.flatMap((i) => mapper2[i]))];
      })
    );
    createMap(
      mapper,
      UserProfile,
      UserProfileViewModel,
      forMember(
        (vm) => vm.license_type,
        mapFrom((m) => m.license_type)
      ),
      forMember(
        (vm) => vm.uid,
        mapFrom((m) => m.uid)
      ),
      forMember(
        (vm) => vm.agent_info,
        mapWith(AgentInfoViewModel, AgentInfo, (m) => m.agent_info)
      ),
      forMember(
        (vm) => vm.username,
        mapFrom((m) => m.username)
      ),
      forMember(
        (vm) => vm.labels,
        mapWith(userLabelViewModelTypeName, userLabelTypeName, (m) => m.labels)
      ),
      forMember(
        (vm) => vm.security_cases,
        mapWith(SecurityCaseViewModel, SecurityCase, (m) => m.security_cases)
      ),
      forMember(
        (vm) => vm.account_status,
        mapFrom((m) => m.account_status)
      ),
      forMember(
        (vm) => vm.deposit_status,
        mapFrom((m) => m.deposit_status)
      ),
      forMember(
        (vm) => vm.casino_status,
        mapFrom((m) => m.casino_status)
      ),
      forMember(
        (vm) => vm.withdrawal_status,
        mapFrom((m) => m.withdrawal_status)
      ),
      forMember(
        (vm) => vm.lobby_access_status,
        mapFrom((m) => m.lobby_access_status)
      ),
      forMember(
        (vm) => vm.p2p_transfer_status,
        mapFrom((m) => m.p2p_transfer_status)
      ),
      forMember(
        (vm) => vm.sportsbook_status,
        mapFrom((m) => m.sportsbook_status)
      ),
      forMember(
        (vm) => vm.brand,
        mapFrom((m) => m.brand)
      ),
      forMember(
        (vm) => vm.license_type,
        mapFrom((m) => m.license_type)
      ),
      forMember(
        (vm) => vm.p2p_override_status,
        mapFrom((m) => m.p2p_override_status)
      ),
      forMember(
        (vm) => vm.p2p_status,
        mapFrom((m) => m.p2p_status)
      )
    );
    createMap(
      mapper,
      AgentInfo,
      AgentInfoViewModel,
      forMember(
        (vm) => vm.revenue_share_history,
        mapWith(
          userProfileMappingKeys.agentRevenueShareViewModelListSerialized,
          userProfileMappingKeys.agentRevenueShareViewModelList,
          (m) => m.default_agent_revenue_share_history
        )
      )
    );
    createMap(
      mapper,
      userProfileMappingKeys.agentRevenueShareViewModelListSerialized,
      userProfileMappingKeys.agentRevenueShareList,
      constructUsing((m) => {
        let parsedModels = null;
        try {
          const parsed = JSON.parse(m?.toString());
          parsedModels = Array.isArray(parsed) ? parsed.filter((i) => i) : [];
        } catch {
          parsedModels = [];
        }
        const dateMask = "yyyy-MM-dd";
        return parsedModels?.slice()?.sort((first, second) => {
          const firstDate = parse(first.active_since, dateMask, /* @__PURE__ */ new Date());
          const secondDate = parse(second.active_since, dateMask, /* @__PURE__ */ new Date());
          return sortByDate(firstDate, secondDate);
        }) ?? [];
      })
    );
    createMap(
      mapper,
      userProfileMappingKeys.agentRevenueShareList,
      userProfileMappingKeys.agentRevenueShareViewModelListSerialized,
      constructUsing(
        (models) => JSON.stringify(
          models.map((model) => ({
            ...model,
            poker_share: model?.poker_cash ? void 0 : model?.poker_share
          }))
        )
      )
    );
    createMap(
      mapper,
      userProfileMappingKeys.agentPokerCash,
      userProfileMappingKeys.agentPokerCashViewModel,
      forMember(
        (vm) => vm.allin_fold,
        mapFrom((m) => convertToPercents(m.allin_fold))
      ),
      forMember(
        (vm) => vm.nlh_sd,
        mapFrom((m) => convertToPercents(m.nlh_sd))
      ),
      forMember(
        (vm) => vm.plo,
        mapFrom((m) => convertToPercents(m.plo))
      ),
      forMember(
        (vm) => vm.squid,
        mapFrom((m) => convertToPercents(m.squid))
      )
    );
    createMap(
      mapper,
      userProfileMappingKeys.agentPokerCashViewModel,
      userProfileMappingKeys.agentPokerCash,
      forMember(
        (m) => m.allin_fold,
        mapFrom((vm) => convertToDecimal(vm.allin_fold))
      ),
      forMember(
        (m) => m.nlh_sd,
        mapFrom((vm) => convertToDecimal(vm.nlh_sd))
      ),
      forMember(
        (m) => m.plo,
        mapFrom((vm) => convertToDecimal(vm.plo))
      ),
      forMember(
        (m) => m.squid,
        mapFrom((vm) => convertToDecimal(vm.squid))
      )
    );
    createMap(
      mapper,
      userProfileMappingKeys.agentPokerShareWeeklyBand,
      userProfileMappingKeys.agentPokerShareWeeklyBandViewModel,
      forMember(
        (vm) => vm.lower_bound,
        mapFrom((m) => m.lower_bound)
      ),
      forMember(
        (vm) => vm.upper_bound,
        mapFrom((m) => m.upper_bound)
      ),
      forMember(
        (vm) => vm.revenue_share,
        mapFrom((m) => convertToPercents(m.revenue_share))
      )
    );
    createMap(
      mapper,
      userProfileMappingKeys.agentPokerShareWeeklyBandViewModel,
      userProfileMappingKeys.agentPokerShareWeeklyBand,
      forMember(
        (m) => m.lower_bound,
        mapFrom((vm) => vm.lower_bound)
      ),
      forMember(
        (m) => m.upper_bound,
        mapFrom((vm) => vm.upper_bound)
      ),
      forMember(
        (m) => m.revenue_share,
        mapFrom((vm) => convertToDecimal(vm.revenue_share))
      )
    );
    createMap(
      mapper,
      userProfileMappingKeys.commissionSubTypes,
      userProfileMappingKeys.commissionAllSubTypesViewModel,
      constructUsing((m) => commissionSubTypesMapping[m] ?? null)
    );
    createMap(
      mapper,
      userProfileMappingKeys.commissionAllSubTypesViewModel,
      userProfileMappingKeys.commissionSubTypes,
      constructUsing((m) => commissionSubTypesViewModelMapping[m] ?? null)
    );
    createMap(
      mapper,
      userProfileMappingKeys.commissionSubTypesModel,
      userProfileMappingKeys.commissionSubTypesViewModel,
      forMember(
        (vm) => vm.poker,
        mapWith(userProfileMappingKeys.commissionAllSubTypesViewModel, userProfileMappingKeys.commissionSubTypes, (m) => m.poker)
      ),
      forMember(
        (vm) => vm.poker_mtt,
        mapWith(userProfileMappingKeys.commissionAllSubTypesViewModel, userProfileMappingKeys.commissionSubTypes, (m) => m.poker_mtt)
      ),
      forMember(
        (vm) => vm.poker_cash_plo,
        mapWith(
          userProfileMappingKeys.commissionAllSubTypesViewModel,
          userProfileMappingKeys.commissionSubTypes,
          (m) => m.poker_cash_plo
        )
      ),
      forMember(
        (vm) => vm.casino,
        mapWith(userProfileMappingKeys.commissionAllSubTypesViewModel, userProfileMappingKeys.commissionSubTypes, (m) => m.casino)
      ),
      forMember(
        (vm) => vm.sports,
        mapWith(userProfileMappingKeys.commissionAllSubTypesViewModel, userProfileMappingKeys.commissionSubTypes, (m) => m.sports)
      ),
      forMember(
        (vm) => vm.spins,
        mapWith(userProfileMappingKeys.commissionAllSubTypesViewModel, userProfileMappingKeys.commissionSubTypes, (m) => m.spins)
      )
    );
    createMap(
      mapper,
      userProfileMappingKeys.commissionSubTypesViewModel,
      userProfileMappingKeys.commissionSubTypesModel,
      forMember(
        (m) => m.poker,
        mapWith(userProfileMappingKeys.commissionSubTypes, userProfileMappingKeys.commissionAllSubTypesViewModel, (vm) => vm.poker)
      ),
      forMember(
        (m) => m.poker_mtt,
        mapWith(
          userProfileMappingKeys.commissionSubTypes,
          userProfileMappingKeys.commissionAllSubTypesViewModel,
          (vm) => vm.poker_mtt
        )
      ),
      forMember(
        (m) => m.poker_cash_plo,
        mapWith(
          userProfileMappingKeys.commissionSubTypes,
          userProfileMappingKeys.commissionAllSubTypesViewModel,
          (vm) => vm.poker_cash_plo
        )
      ),
      forMember(
        (m) => m.casino,
        mapWith(userProfileMappingKeys.commissionSubTypes, userProfileMappingKeys.commissionAllSubTypesViewModel, (vm) => vm.casino)
      ),
      forMember(
        (m) => m.sports,
        mapWith(userProfileMappingKeys.commissionSubTypes, userProfileMappingKeys.commissionAllSubTypesViewModel, (vm) => vm.sports)
      ),
      forMember(
        (m) => m.spins,
        mapWith(userProfileMappingKeys.commissionSubTypes, userProfileMappingKeys.commissionAllSubTypesViewModel, (vm) => vm.spins)
      )
    );
    createMap(
      mapper,
      userProfileMappingKeys.agentRevenueShare,
      userProfileMappingKeys.agentRevenueShareViewModel,
      forMember(
        (vm) => vm.active_since,
        mapFrom((m) => m.active_since)
      ),
      forMember(
        (vm) => vm.casino_share,
        mapFrom((m) => convertToPercents(m.casino_share))
      ),
      forMember(
        (vm) => vm.net_deposit_share,
        mapFrom((m) => convertToPercents(m.net_deposit_share))
      ),
      forMember(
        (vm) => vm.player_winloss,
        mapFrom((m) => convertToPercents(m.player_winloss))
      ),
      forMember(
        (vm) => vm.gross_deposit,
        mapFrom((m) => convertToPercents(m.gross_deposit))
      ),
      forMember(
        (vm) => vm.spins,
        mapFrom((m) => convertToPercents(m.spins))
      ),
      forMember(
        (vm) => vm.poker_mtt,
        mapFrom((m) => convertToPercents(m.poker_mtt))
      ),
      forMember(
        (vm) => vm.sports,
        mapFrom((m) => convertToPercents(m.sports))
      ),
      forMember(
        (vm) => vm.poker_cash,
        mapWith(userProfileMappingKeys.agentPokerCashViewModel, userProfileMappingKeys.agentPokerCash, (m) => m.poker_cash)
      ),
      forMember(
        (vm) => vm.poker_share?.weekly_bands,
        mapWith(
          userProfileMappingKeys.agentPokerShareWeeklyBandViewModel,
          userProfileMappingKeys.agentPokerShareWeeklyBand,
          (m) => m.poker_share?.weekly_bands
        )
      ),
      forMember(
        (vm) => vm.commission_subtypes,
        mapWith(
          userProfileMappingKeys.commissionSubTypesViewModel,
          userProfileMappingKeys.commissionSubTypes,
          (m) => m.commission_subtypes
        )
      )
    );
    createMap(
      mapper,
      userProfileMappingKeys.agentRevenueShareViewModel,
      userProfileMappingKeys.agentRevenueShareInput,
      forMember(
        (m) => m.casino_share,
        mapFrom((vm) => convertToDecimal(vm.casino_share))
      ),
      forMember(
        (m) => m.commission_subtypes,
        mapWith(
          userProfileMappingKeys.commissionSubTypes,
          userProfileMappingKeys.commissionSubTypesViewModel,
          (vm) => vm.commission_subtypes
        )
      ),
      forMember(
        (m) => m.poker_cash,
        mapFrom((vm) => convertToDecimal(vm.poker_cash?.nlh_sd))
      ),
      forMember(
        (m) => m.poker_cash_plo,
        mapFrom((vm) => convertToDecimal(vm.poker_cash?.plo))
      ),
      forMember(
        (m) => m.poker_mtt,
        mapFrom((vm) => convertToDecimal(vm.poker_mtt))
      ),
      forMember(
        (m) => m.spins,
        mapFrom((vm) => convertToDecimal(vm.spins))
      ),
      forMember(
        (m) => m.sports,
        mapFrom((vm) => convertToDecimal(vm.sports))
      )
    );
    createMap(
      mapper,
      userProfileMappingKeys.agentRevenueShareViewModelListSerialized,
      userProfileMappingKeys.agentRevenueShareViewModelList,
      constructUsing((m) => {
        let parsedVms = null;
        try {
          parsedVms = JSON.parse(m.toString());
        } catch {
          parsedVms = [];
        }
        const updatedVms = produce(parsedVms, (draftState) => {
          draftState.forEach((parsedVm) => {
            parsedVm.casino_share = convertToPercents(parsedVm?.casino_share);
            parsedVm.gross_deposit = convertToPercents(parsedVm?.gross_deposit);
            parsedVm.net_deposit_share = convertToPercents(parsedVm?.net_deposit_share);
            parsedVm.player_winloss = convertToPercents(parsedVm?.player_winloss);
            parsedVm.spins = convertToPercents(parsedVm?.spins);
            parsedVm.poker_mtt = convertToPercents(parsedVm?.poker_mtt);
            parsedVm.sports = convertToPercents(parsedVm?.sports);
            Object.keys(parsedVm?.poker_cash ?? {}).forEach(
              (key) => parsedVm.poker_cash[key] = convertToPercents(parsedVm.poker_cash?.[key])
            );
            (parsedVm?.poker_share?.weekly_bands ?? []).forEach(
              (weeklyBand) => weeklyBand.revenue_share = convertToPercents(weeklyBand?.revenue_share)
            );
          });
        });
        const dateMask = "yyyy-MM-dd";
        return updatedVms?.slice()?.sort((first, second) => {
          const firstDate = parse(first.active_since, dateMask, /* @__PURE__ */ new Date());
          const secondDate = parse(second.active_since, dateMask, /* @__PURE__ */ new Date());
          return sortByDate(firstDate, secondDate);
        }) ?? [];
      })
    );
    createMap(
      mapper,
      userProfileMappingKeys.agentRevenueShareViewModelList,
      userProfileMappingKeys.agentRevenueShareViewModelListSerialized,
      constructUsing((vms) => {
        const updatedVms = produce(vms, (draftState) => {
          draftState.forEach((vm) => {
            if (vm?.poker_cash) {
              delete vm?.poker_share;
              Object.keys(vm?.poker_cash ?? {}).forEach(
                (key) => vm.poker_cash[key] = convertToDecimal(vm?.poker_cash?.[key])
              );
            } else {
              (vm?.poker_share?.weekly_bands ?? []).forEach((weeklyBand) => {
                weeklyBand.revenue_share = convertToDecimal(weeklyBand?.revenue_share);
              });
            }
            vm.casino_share = convertToDecimal(vm?.casino_share);
            vm.gross_deposit = convertToDecimal(vm?.gross_deposit);
            vm.net_deposit_share = convertToDecimal(vm?.net_deposit_share);
            vm.player_winloss = convertToDecimal(vm?.player_winloss);
            vm.spins = convertToDecimal(vm?.spins);
            vm.poker_mtt = convertToDecimal(vm?.poker_mtt);
            vm.sports = convertToDecimal(vm?.sports);
          });
        });
        return JSON.stringify(updatedVms);
      })
    );
    createMap(
      mapper,
      UserProfileViewModelKeysTypeName,
      UserProfileColumnSettingsKeysTypeName,
      constructUsing((m) => {
        const mapping = {
          "agent_info.is_agent": null,
          "birthday.seconds": null,
          bonus_ratio: null,
          casino_status: null,
          sportsbook_status: null,
          "date_of_joining.seconds": "date_of_joining",
          "finance.balance": "balance",
          "finance.withdrawal.total.pending_count": "pending_count",
          gender: null,
          ggr: null,
          is_2fa_enabled: null,
          is_challenge_questions_enabled: null,
          "latest_kyc.payment.account_verification_status": "latest_payment_kyc_status",
          "latest_kyc.payment.account_verification_status_cs": "latest_payment_kyc_status",
          "latest_kyc.security.account_verification_status": "latest_security_kyc_status",
          "latest_kyc.security.id": null,
          "latest_login.logged_at_ts.seconds": "latest_login_time",
          lifetime_bonus: null,
          lobby_access_status: null,
          "phone.area": null,
          "phone.number": null,
          verified_phone: null,
          verified_email: null,
          platform_narrow: "platform",
          "referral.personal_referral_link": null,
          "security_cases.case_id": null,
          "security_cases.type": null,
          "security_cases.closed_at": null,
          "security_cases.opened_at": null,
          uid_link_agent: "uid",
          uid_link_cs: "uid",
          uid_link_security: "uid",
          uid_link_player_details: "uid",
          uid_link_agent_details: "uid",
          "latest_kyc.payment.id": null,
          "networks.uid": null,
          "networks.platform": null,
          aml_labels: null,
          vpn: null,
          "finance.casino_coin_balance": "casino_coin_balance",
          "finance.p2p_credit.successful_amount": null,
          "finance.p2p_debit.successful_amount": null,
          p2p_override_status: null,
          commission_subtypes: null,
          master_agent_id: null,
          "finance.withdrawable_balance": "withdrawable_balance",
          "finance.non_withdrawable_balance": null
        };
        const mappedValue = mapping[m];
        return mappedValue === void 0 ? m : mappedValue;
      })
    );
    createMap(
      mapper,
      UserProfileColumnSettingsKeysTypeName,
      UserProfileViewModelKeysTypeName,
      constructUsing((m) => {
        const mapping = {
          __type: [],
          balance: ["balance", "finance.balance"],
          latest_payment_kyc_status: [
            "latest_kyc.payment.account_verification_status",
            "latest_kyc.payment.account_verification_status_cs"
          ],
          latest_security_kyc_status: ["latest_kyc.security.account_verification_status"],
          latest_login_time: ["latest_login.logged_at_ts.seconds"],
          platform: ["platform", "platform_narrow"],
          uid: ["uid", "uid_link_agent", "uid_link_cs", "uid_link_security", "uid_link_player_details", "uid_link_agent_details"],
          date_of_joining: ["date_of_joining.seconds"],
          pending_count: ["finance.withdrawal.total.pending_count"],
          casino_coin_balance: ["finance.casino_coin_balance"],
          withdrawable_balance: ["finance.withdrawable_balance"]
        };
        const mappedValue = mapping[m];
        return mappedValue === void 0 ? [m] : mappedValue;
      })
    );
    createMap(
      mapper,
      UserProfile,
      UserProfileDownloadModel,
      forMember(
        (vm) => vm.uid,
        mapFrom((m) => m.uid)
      ),
      forMember(
        (vm) => vm.full_name,
        mapFrom((m) => m.first_name || m.last_name ? `${m.first_name} ${m.last_name}` : void 0)
      ),
      forMember(
        (vm) => vm.nickname,
        mapFrom((m) => m.nickname)
      ),
      forMember(
        (vm) => vm.platform,
        mapFrom((m) => m.platform === Platform.Wpto ? "WPTG" : m.platform)
      ),
      forMember(
        (vm) => vm.platform_narrow,
        mapFrom((m) => m.platform === Platform.Wpto ? "WPTG" : m.platform)
      ),
      forMember(
        (vm) => vm.account_status,
        mapFrom((m) => m.account_status)
      ),
      forMember(
        (vm) => vm.withdrawal_status,
        mapFrom((m) => m.withdrawal_status)
      ),
      forMember(
        (vm) => vm.deposit_status,
        mapFrom((m) => m.deposit_status)
      ),
      forMember(
        (vm) => vm.security_cases,
        mapFrom((m) => m.security_cases?.map((c) => c.case_id)?.join())
      ),
      forMember(
        (vm) => vm["latest_kyc.payment.account_verification_status"],
        mapFrom((m) => m.latest_kyc?.payment?.account_verification_status)
      ),
      forMember(
        (vm) => vm["latest_kyc.payment.account_verification_status_cs"],
        mapFrom((m) => m.latest_kyc?.payment?.account_verification_status)
      ),
      forMember(
        (vm) => vm["latest_kyc.security.account_verification_status"],
        mapFrom((m) => m.latest_kyc?.security?.account_verification_status)
      ),
      forMember(
        (vm) => vm.phone,
        mapFrom((m) => m.contact?.mobile?.full_number)
      ),
      forMember(
        (vm) => vm.referrer_player_id,
        mapFrom((m) => m.referral?.inviting_user_id)
      ),
      forMember(
        (vm) => vm.referrer_username,
        mapFrom((m) => m.referral?.inviting_user_username)
      ),
      forMember(
        (vm) => vm.referred_date,
        mapFrom((m) => formatTimestamp(m.referral?.referred_at, "date") ?? void 0)
      ),
      forMember(
        (vm) => vm.email,
        mapFrom((m) => m.contact?.email)
      ),
      forMember(
        (vm) => vm.username,
        mapFrom((m) => m.username)
      ),
      forMember(
        (vm) => vm["finance.balance"],
        mapFrom((m) => m.finance?.balance?.toString())
      ),
      forMember(
        (vm) => vm["finance.casino_coin_balance"],
        mapFrom((m) => m.finance?.casino_coin_balance?.toString())
      ),
      forMember(
        (vm) => vm.p2p_transfer_status,
        mapFrom((m) => m.p2p_transfer_status)
      ),
      forMember(
        (vm) => vm.uid_link_security,
        mapFrom((m) => m.uid)
      ),
      forMember(
        (vm) => vm.uid_link_cs,
        mapFrom((m) => m.uid)
      ),
      forMember(
        (vm) => vm.uid_link_agent,
        mapFrom((m) => m.uid)
      ),
      forMember(
        (vm) => vm.uid_link_player_details,
        mapFrom((m) => m.uid)
      ),
      forMember(
        (vm) => vm.uid_link_agent_details,
        mapFrom((m) => m.uid)
      ),
      forMember(
        (vm) => vm.register_marketing_code,
        mapFrom((m) => m.marketing_info?.register_marketing_code)
      ),
      forMember(
        (vm) => vm.referrer,
        mapFrom((m) => m?.affiliate?.btag ?? m?.referral?.inviting_user_id)
      ),
      forMember(
        (vm) => vm.labels,
        mapFrom((m) => m.labels?.map((l) => l.name)?.join())
      ),
      forMember(
        (vm) => vm.national_id,
        mapFrom((m) => m.region_player_info?.national_id)
      ),
      forMember(
        (vm) => vm.networks_PKW,
        mapFrom((m) => m?.networks?.find((item) => item.platform === Platform.Pkw)?.uid)
      ),
      forMember(
        (vm) => vm.networks_BL,
        mapFrom((m) => m?.networks?.find((item) => item.platform === Platform.Bl)?.uid)
      ),
      forMember(
        (vm) => vm["latest_login.logged_at_ts.seconds"],
        mapFrom((m) => formatTimestamp(m.latest_login?.logged_at_ts, "date-time-with-seconds") ?? void 0)
      ),
      forMember(
        (vm) => vm.withdrawal_approved_amount,
        mapFrom((m) => m.finance?.withdrawal?.total?.successful_amount?.toString())
      ),
      forMember(
        (vm) => vm.withdrawal_approved_count,
        mapFrom((m) => m.finance?.withdrawal?.total?.successful_count?.toString())
      ),
      forMember(
        (vm) => vm.withdrawal_pending_amount,
        mapFrom((m) => m.finance?.withdrawal?.total?.pending_amount?.toString())
      ),
      forMember(
        (vm) => vm["finance.withdrawal.total.pending_count"],
        mapFrom((m) => m.finance?.withdrawal?.total?.pending_count?.toString())
      ),
      forMember(
        (vm) => vm.country,
        mapFrom((m) => m?.address?.country_info?.iso_alpha2_code)
      ),
      forMember(
        (vm) => vm.login_countries,
        mapFrom((m) => m?.countries?.join())
      ),
      forMember(
        (vm) => vm.first_name,
        mapFrom((m) => m?.first_name)
      ),
      forMember(
        (vm) => vm.last_name,
        mapFrom((m) => m?.last_name)
      ),
      forMember(
        (vm) => vm["date_of_joining.seconds"],
        mapFrom((m) => formatTimestamp(m?.date_of_joining, "date-time-with-seconds") ?? void 0)
      ),
      forMember(
        (vm) => vm.brand,
        mapFrom((m) => m?.brand)
      ),
      forMember(
        (vm) => vm.license_type,
        mapFrom((m) => m?.license_type)
      ),
      forMember(
        (vm) => vm.deposit_total,
        mapFrom((m) => m?.finance?.deposit?.total?.successful_amount?.toString())
      ),
      forMember(
        (vm) => vm.withdrawal_total,
        mapFrom((m) => m?.finance?.withdrawal?.total?.successful_amount?.toString())
      ),
      forMember(
        (vm) => vm.casino_ggr_lifetime,
        mapFrom((m) => m?.finance?.ggr_lifetime?.casino?.toString())
      ),
      forMember(
        (vm) => vm.poker_ggr_lifetime,
        mapFrom((m) => m?.finance?.ggr_lifetime?.poker?.toString())
      ),
      forMember(
        (vm) => vm.sports_ggr_lifetime,
        mapFrom((m) => m?.finance?.ggr_lifetime?.sports?.toString())
      ),
      forMember(
        (vm) => vm.aal,
        mapFrom((m) => m?.aal?.join())
      ),
      forMember(
        (vm) => vm["finance.withdrawable_balance"],
        mapFrom((m) => m?.finance?.withdrawable_balance?.toString())
      ),
      forMember(
        (vm) => vm.p2p_status,
        mapFrom((m) => {
          const hasGlobalSettings = !m?.p2p_override_status;
          return hasGlobalSettings ? "Global" : m?.p2p_status;
        })
      ),
      forMember(
        (vm) => vm.channel,
        mapFrom((m) => m?.channel ?? Channel.None)
      )
    );
    createMap(
      mapper,
      AgentRevenueShareViewModelTypeName,
      UserProfileDownloadModel,
      forMember(
        (vm) => vm["agent_info.latest_revenue_share.casino_share"],
        mapFrom((m) => m?.casino_share?.toString())
      ),
      forMember(
        (vm) => vm["agent_info.latest_revenue_share.poker_cash.nlh_sd"],
        mapFrom((m) => m?.poker_cash?.nlh_sd?.toString())
      ),
      forMember(
        (vm) => vm["agent_info.latest_revenue_share.poker_cash.plo"],
        mapFrom((m) => m?.poker_cash?.plo?.toString())
      ),
      forMember(
        (vm) => vm["agent_info.latest_revenue_share.poker_mtt"],
        mapFrom((m) => m?.poker_mtt?.toString())
      ),
      forMember(
        (vm) => vm["agent_info.latest_revenue_share.spins"],
        mapFrom((m) => m?.spins?.toString())
      ),
      forMember(
        (vm) => vm["agent_info.latest_revenue_share.sports"],
        mapFrom((m) => m?.sports?.toString())
      )
    );
    createMap(
      mapper,
      Array,
      AalViewModel,
      forMember(
        (vm) => vm.isRowUser,
        mapFrom((m) => {
          const aalRowGroup = "aal_row";
          return !!m?.find((aal) => aal === aalRowGroup);
        })
      ),
      forMember(
        (vm) => vm.isOtherUser,
        mapFrom((m) => {
          const aalRowGroup = "aal_row";
          return !m?.includes(aalRowGroup);
        })
      )
    );
    createMap(
      mapper,
      userProfileMappingKeys.userProfileViewModelKeys,
      userProfileMappingKeys.userProfileDownloadFields,
      constructUsing((m) => {
        const mapper2 = {
          uid_link_agent_details: "uid",
          uid_link_player_details: "uid",
          username: "username",
          nickname: "nickname",
          "finance.balance": "finance.balance",
          "finance.casino_coin_balance": "finance.casino_coin_balance",
          "finance.withdrawable_balance": "finance.withdrawable_balance",
          "agent_info.latest_revenue_share.poker_cash.nlh_sd": "agent_info.latest_revenue_share.poker_cash.nlh_sd",
          "agent_info.latest_revenue_share.poker_mtt": "agent_info.latest_revenue_share.poker_mtt",
          "agent_info.latest_revenue_share.poker_cash.plo": "agent_info.latest_revenue_share.poker_cash.plo",
          "agent_info.latest_revenue_share.casino_share": "agent_info.latest_revenue_share.casino_share",
          "agent_info.latest_revenue_share.spins": "agent_info.latest_revenue_share.spins",
          "agent_info.latest_revenue_share.sports": "agent_info.latest_revenue_share.sports",
          email: "contact.email",
          register_marketing_code: "marketing_info.register_marketing_code",
          country: "address.country_info.iso_alpha2_code",
          referrer_player_id: "referral.inviting_user_id",
          referrer_username: "referral.inviting_user_username",
          referred_date: "referral.referred_at.seconds",
          deposit_status: "deposit_status",
          withdrawal_status: "withdrawal_status",
          p2p_status: "p2p_status",
          platform_narrow: "platform",
          brand: "brand",
          license_type: "license_type",
          aal: "aal",
          "referral.personal_referral_code": "referral.personal_referral_code"
        };
        return mapper2[m];
      })
    );
  }
}
export {
  UserProfileMapping,
  userProfileMappingKeys
};
//# sourceMappingURL=mapper.js.map
